var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('left-drawer',{on:{"set-content":_vm.setSubDrawerContent,"set-sub-menu-name":_vm.setSubDrawerName}}),_c('sub-drawer',{attrs:{"children":_vm.subDrawerContent,"name":_vm.subDrawerName}}),_c('top-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }